"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query ProductListingFacets($pageId: ID!, $facetFiltering: [EditorialPlpRowsFacetFilterInput!] = []) {\n    application {\n      editorialPage(pageId: $pageId, channelType: Web) {\n        contentItems {\n          __typename\n          ... on EditorialPlpRows {\n            content(top: 1, facetFiltering: $facetFiltering) {\n              ...ProductListingFacetsRows\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingFacetsQuery = void 0;
var _fetching = require("@ori/fetching");
var _productListingFacetsRows = require("./fragments/productListingFacetsRows");
/* istanbul ignore file @preserve -- query */ const productListingFacetsQuery = exports.productListingFacetsQuery = (0, _fetching.gql)(_templateObject(), _productListingFacetsRows.productListingFacetsRows);
